import GlobalActions from 'store/redux/global'
import store from 'store'

export const emptyAlert = {
    children: '',
    color: '',
    id: '',
    footer: '',
    title: ''
}

const colorMapping = {
    error: 'danger',
    info: 'info',
    success: 'success'
}

export const basicAlert = ({ type, title, children, footer, id }) => ({
    children,
    color: colorMapping[type],
    id,
    footer,
    title
})

export const dismisableAlert = ({ type, title, children, footer, id }) => ({
    ...basicAlert({ type, title, children, footer, id }),
    ...{
        dismiss: true,
        onDismiss: () => {
            if (store) store.dispatch(GlobalActions.closeAlert())
        }
    }
})



// WEBPACK FOOTER //
// src/utils/generators/alert.js